import { t } from "@/lib/localization";

const VIDEO_EXTENSIONS = /\.(mp4|webm|ogg)(\?|$)/i;
const IMAGE_EXTENSIONS = /\.(png|jpg|jpeg|webp)(\?|$)/i;

export function isVideoUrl(url: string): boolean {
    const t = url.trim().toLowerCase();
    return VIDEO_EXTENSIONS.test(t) || t.startsWith("data:video/");
}

export function isImageUrl(url: string): boolean {
    const t = url.trim().toLowerCase();
    return IMAGE_EXTENSIONS.test(t) || t.startsWith("data:image/");
}

/** Video or image URL (fetchable by backend for media items). */
export function isMediaUrl(url: string): boolean {
    return isVideoUrl(url) || isImageUrl(url);
}

/** Backend supports http(s) and data: URLs. blob: URLs must be converted before sending. */
export function isUsableMediaUrl(url: string): boolean {
    const t = url.trim().toLowerCase();
    return (
        t.startsWith("http://") ||
        t.startsWith("https://") ||
        t.startsWith("data:video/") ||
        t.startsWith("data:image/")
    );
}

/** blob: URLs cannot be used by the backend; convert to data: or upload first. */
export function isBlobUrl(url: string): boolean {
    return url.trim().toLowerCase().startsWith("blob:");
}

export function getAssetMediaType(
    fileType?: string
): "image" | "video" | "audio" {
    if (!fileType) return "image";
    if (fileType.startsWith("image/")) return "image";
    if (fileType.startsWith("video/")) return "video";
    return "image";
}

export function formatDate(date: Date): string {
    return date.toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
}

export function formatFileSize(bytes?: number): string {
    if (bytes == null || bytes === 0) return "—";
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return `${Math.round(mb)} MB`;
    const kb = bytes / 1024;
    return `${Math.round(kb)} KB`;
}

export function getDisplayFileType(fileType?: string): string {
    if (!fileType) return t("lomda-editor.sidebar.media.preview.type-image");
    if (fileType.startsWith("image/"))
        return t("lomda-editor.sidebar.media.preview.type-image");
    if (fileType.startsWith("video/"))
        return t("lomda-editor.sidebar.media.preview.type-video");
    if (fileType.startsWith("audio/"))
        return t("lomda-editor.sidebar.media.preview.type-audio");
    return fileType;
}

export function formatDuration(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s.toString().padStart(2, "0")}`;
}
